import jquery from 'jquery';
// lodash
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _keyBy from 'lodash/keyBy';
import _merge from 'lodash/merge';
import _reduce from 'lodash/reduce';
import _size from 'lodash/size';
import _toFinite from 'lodash/toFinite';
import _lowerCase from 'lodash/lowerCase';
import _replace from 'lodash/replace';

import EventBus from '@/event-bus';
import _Instance from '@/product-instance';
import _Options from '@/product/options.build';
import _PriceKinds from '@/product/priceKinds';
import _Properties from '@/product/properties';
import _Settings from '@/product/settings';
import _Tree from '@/product/tree.build';
import Shop from '@/shop';
import Error from '@/tools/error';
import perfDebug from '@/helpers/perfDebug';

import variant from '@/product/default-variant.json';

/**
 * Главный объект продукта
 *
 * @class
 *
 * @param {json} product json с информацией о товаре
 * @param {object} settings конфиг для рендера optionSelector
 *
 * @todo Превратить в справочник всей подготовленной информации по товару
 * @private
 */
var Product = function(product, settings) {
  var self = this;

  //console.debug('Product: constructor: product: ', product);
  //console.debug('Product: constructor: settings: ', settings);
  // Банхамер должен быть на входе
  if (!product) {
    throw new Error('ErrorProduct', 'ошибка в передаче продукта');
  }

  //  Валидация настроек
  self.product = product;
  self.id = product.id;
  self.settings = new _Settings(settings);
  self._selectors = self.settings.getSettings().selectors.product;
  self._init();
  self._initInstance();

  //console.debug('Product: constructor: self: ', self);
};

/**
 * @public
 * @description
 * Инитим продукт
 */
Product.prototype._init = function() {
  var self = this;
  var _product;

  _product = self._prepareProduct(self.product);
  self.tree = new _Tree(_product.variants);
  self.variants = self._prepareVariants(_product.variants);
  self.images = self._getImage(_product.images);
};

/**
 * @public
 * @description
 * Получаем информацию товара без лишних палей
 */
Product.prototype.getProduct = function() {
  var self = this;
  var _product;

  if (!self.product) {
    self.product = {};
  }
  _product = self.product;

  return _product;
};

Product.prototype._prepareProduct = function(productJSON) {
  var self = this;
  var _product = self.getProduct();

  _merge(_product,
    productJSON,
    self._patchPrices(productJSON.variants)
  );

  _product.variants = self._checkOutOfStock(productJSON.variants);
  self._patchVariantImages(_product);

  _product.options = new _Options(productJSON.option_names, _product.variants);
  _product.properties = new _Properties(productJSON.properties, productJSON.characteristics);

  _product.accessories = _keyBy(productJSON.accessories, 'id');

  _product.price_kinds = new _PriceKinds(productJSON.price_kinds, _product.variants);

  const variantsByValueId = new Map();
  _forEach(_product.variants, function(variant) {
    _forEach(variant.option_values, function(option_value) {
      if (!variantsByValueId.has(option_value.id)) {
        variantsByValueId.set(option_value.id, []);
      }
      variantsByValueId.get(option_value.id).push({
        title: variant.title,
        available: variant.available,
        id: variant.id
      });
    });
  });

  // Использовать индекс для заполнения variantsList
  _forEach(_product.options, function(option, i) {
    _forEach(option.values, function(value, i) {
      value.variantsList = variantsByValueId.get(value.id) || [];
    });
  });

  return _product;
};

/**
 * @private
 * Изменяем формат представления вариантов
 * Так же учитываем тот случай, когда поставлена галка
 * "Скрывать отсутствующие позиции"
 */
Product.prototype._prepareVariants = function(variants) {
  var _variants = {};

  _variants = _keyBy(variants, 'id');
  //console.debug('Product: _prepareVariants: _variants:', _variants);

  return _variants;
};

/**
 * @private
 *
 * @description
 * Производит обработку входного массива вариантов с учетом состояния флага "скрыть товар с 0 остатком"
 * При установленном флажке, из исходного массива должен быть выкинуты все варианты с количеством = 0
 * Так же надо учитвать вариант, что могли придти по прямой ссылке, тогда надо в пустой массив вставить фейковый вариант, чтобы не сломать все остальные скрипты.
 *
 * @param {Array} variants - массив вариантов товара
 *
 * @return {Array} - массив вариантов, отфильтрованные с учетом флага "скртыть товары с 0 остатком"
 */
Product.prototype._checkOutOfStock = function(variants) {
  var self = this;
  var productCharacteristics = self.product.characteristics.map(item => item.id) || [];
  // eslint-disable-next-line max-len
  var paramsForShowStockOut = Shop.config.get('available_products_characteristics_ids').available_products_characteristics_ids || [];
  var paramsForShowInProduct = productCharacteristics.filter(value => paramsForShowStockOut.includes(value));
  var _hideStokOut = Shop.config.get('hide_items_out_of_stock').hide_items_out_of_stock;
  var _variants;
  var settings = self.settings.getSettings();

  if (settings.disableHideItem || paramsForShowInProduct.length > 0) {
    _hideStokOut = false;
  }

  _variants = _filter(variants, function(_variant) {
    if (!(_hideStokOut && _variant.quantity === 0)) {
      return _variant;
    }
  });

  if (!_variants.length) {
    _variants.push(self._prepareFakeVariant());
  }

  return _variants;
};

/**
 * @description
 * Подготовка специального фейкового варианта для заглушки пустого массива product.variants
 *
 * @return {Object} - готовый фейковый вариант
 */
Product.prototype._prepareFakeVariant = function() {
  var self = this;
  var _product = self.product;
  var _variant = variant;

  _variant.product_id = _product.id;
  _variant.price = _product.price;
  _variant.old_price = _product.old_price;

  return _variant;
};

/**
 * Получаем объект с изображениями где ключом является название изображения
 * @private
 *
 * @param {array} images массив изображений продукта (product.images)
 *
 * @return {object} _images объект с изображениями в виде {'image.title': {small_url: 'http//'}}
 */
Product.prototype._getImage = function(images) {
  var self = this;

  var _images = {};
  //  если у продукта есть изображения
  if (_size(images) > 0) {
    _forEach(images, function(image) {
      //  если у изображения есть title
      if (image.title) {
        var imageName = _lowerCase(_replace(image.title, 'й', 'й'));

        _images[imageName] = {
          thumb_url: image.thumb_url,
          small_url: image.small_url,
          medium_url: image.medium_url,
          large_url: image.large_url,
          original_url: image.original_url
        };
      }
    });
  }

  return _images;
};

/**
 * Инициализация оберток [data-product-id] с инициализацией всех дочерних элементов
 * @private
 */
Product.prototype._initInstance = function() {
  var self = this;

  self._instance = {};
  self.$product = jquery('[' + self._selectors.product.attr + '="' + self.id + '"]');
  self.$product.each(function(index, _node) {
    var _instanceConfig = self._getInstanceConfig(jquery(_node));
    if (!_node.Product) {
      self._instance[index] = new _Instance(_merge(
        _instanceConfig,
        { instanceId: self.id + ':' + index }
      ),
      jquery(_node)
      );
    }

    var taskEvent = {
      action: {
        method: 'init_instance',
        product: self.$product,
        productJSON: self.product,
        productInstance: self.$product
      }
    };

    EventBus.publish('init_instance:insales:product', taskEvent);
  });
};

/**
 * @private
 *
 * @description
 * Тянем основную инфу из продукта
 */
Product.prototype._getInstanceConfig = function($node) {
  var self = this;
  var _product = self.getProduct();

  return {
    settings: self.settings.getSettings($node),
    options: _product.options.getOptions(),
    price_kinds: _product.price_kinds.getPriceKinds(),
    tree: self.tree.getTree(),
    variants: self.variants,
    product: _product,
    images: self.images,
  };
};

/**
 * @description
 * Получить варианты свойства
 */
Product.prototype.getVariantsByOptionId = function(optionId) {
  var self = this;
  var result = null;

  _forEach(self.getProduct().options, function(option, i) {
    _forEach(option.values, function(value, i) {
      if (value.id == optionId) {
        result = value.variantsList;
      }
    });
  });

  return result;
};

/**
 * @description
 * Устанавливаем новые конфиги
 */
Product.prototype.setConfig = function(settings) {
  var self = this;

  self.settings.set(settings);
  self._init();
  _forEach(self._instance, function(_instance) {
    _instance.setConfig(self.settings.getSettings());
  });
};

/**
 * @private
 * @description
 * Патчим исходный объект и вытаскиваем наружу цены.
 * За основу берем представление продукта в ликвиде
 */
Product.prototype._patchPrices = function(variants) {
  var _prices = {};

  if (variants.length === 0) { return _prices; }

  let old_price_min = Infinity;
  let old_price_max = -Infinity;
  let price_min = Infinity;
  let price_max = -Infinity;
  let first_available_variant = null;

  variants.forEach(_variant => {
    const oldPrice = _toFinite(_variant.old_price);
    const price = _toFinite(_variant.price);

    // Старые цены
    if (oldPrice < old_price_min) { old_price_min = oldPrice; }
    if (oldPrice > old_price_max) { old_price_max = oldPrice; }

    // Текущие цены (max для всех)
    if (price > price_max) { price_max = price; }

    // Доступные варианты
    if (_variant.available) {
      if (!first_available_variant) { first_available_variant = _variant; }
      if (price < price_min) { price_min = price; }
    }
  });

  // Формируем результат
  _prices.old_price = variants[0].old_price;
  _prices.old_price_min = old_price_min !== Infinity ? old_price_min : _prices.old_price;
  _prices.old_price_max = old_price_max !== -Infinity ? old_price_max : _prices.old_price;
  _prices.old_price_varies = (_prices.old_price_min !== _prices.old_price_max);

  _prices.price = first_available_variant ? first_available_variant.price : variants[0].price;
  _prices.price_min = price_min !== Infinity ? price_min : _prices.price;
  _prices.price_max = price_max !== -Infinity ? price_max : _prices.price;
  _prices.price_varies = (_toFinite(_prices.price_min) !== _toFinite(_prices.price_max));

  return _prices;
};

Product.prototype._patchVariantImages = function(product) {
  var _images = product.images;

  _forEach(product.variants, function(variant) {
    var _image = _filter(_images, { id: variant.image_id })[0];

    //console.debug('Product: _patchVariantImages: _image: ', _image);
    if (_image) {
      _image.from_variant = true;
    } else {
      _image = product.first_image;

      if (_image) {
        _image.from_variant = false;
      }
    }
    variant.images = _image ? [ _image ] : [];
    variant.first_image = _image;
    //console.debug('Product: _patchVariantImages: variant: ', variant);
  });

  return;
};

export default Product;

perfDebug.logModuleEval('@/product/index');
